'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var classNames = require('classnames');

module.exports = React.createClass({
	displayName: 'Card',
	propTypes: {
		children: React.PropTypes.node.isRequired,
		className: React.PropTypes.string
	},
	render: function render() {
		var className = classNames('Card', this.props.className);

		return React.createElement('div', _extends({}, this.props, { className: className }));
	}
});


//////////////////
// WEBPACK FOOTER
// ./~/elemental/lib/components/Card.js
// module id = 329
// module chunks = 0